import { QueryClient } from '@tanstack/react-query'

// The app's one query cache (App.tsx provides it). A module, so code outside
// React (an agent turn ending) can invalidate queries too.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
    },
  },
})
